(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('TaskPanel', TaskPanel);

    TaskPanel.$inject = ['$resource'];

    function TaskPanel ($resource) {
        var resourceUrl =  'api/observations/panel-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
